import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const FaceFlatSmileIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fill="currentColor"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8 15C11.866 15 15 11.866 15 8C15 4.13403 11.866 1 8 1C4.134 1 1 4.13403 1 8C1 11.866 4.134 15 8 15ZM10 5C9.44772 5 9 5.44769 9 6V6.5C9 6.77612 9.22385 7 9.5 7H10.5C10.7762 7 11 6.77612 11 6.5V6C11 5.44769 10.5523 5 10 5ZM5 6C5 5.44769 5.44772 5 6 5C6.55228 5 7 5.44769 7 6V6.5C7 6.77612 6.77615 7 6.5 7H5.5C5.22385 7 5 6.77612 5 6.5V6ZM4.75 9.25C4.33578 9.25 4 9.58582 4 10C4 10.4142 4.33578 10.75 4.75 10.75H11.25C11.6642 10.75 12 10.4142 12 10C12 9.58582 11.6642 9.25 11.25 9.25H4.75Z"
			/>
		</svg>
	),
)
